<template>
  <div>
    <div class="examModel" @mousemove.prevent>
      <div class="mask" @mousemove.prevent></div>
      <div class="content1">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ExamModel",
  props: {
    examModel: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="less" scoped>
.examModel {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }

  .content1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    width: 451px;
    height: 245px;
  }
}
</style>
